import axios from 'axios';
import { GET_TRANSACTIONS_URL } from "../constants/index";
import { IITransactionParams } from '../interfaces/transaction';


export function getTransactions(data: IITransactionParams) {
  return axios.get(GET_TRANSACTIONS_URL, {params: {
    searchText: data.searchText,
    type: data.type,
    asset: data.asset,
    status: data.status,
    from: data.from,
    to: data.to,
    page: data.page,
    size: data.size,
    sort: 'opened,desc'
  }});
}